/**
 * Sample assessment scores for the Age 10-12 personality report.
 *
 * These are computed deterministically from the LeadXKids Big Five
 * QuestionBank Excel (Child 10-12 + Parent 10-12, 40 Qs each, 8 items
 * per trait). A fixed answer pattern was chosen to produce a realistic,
 * varied profile a 10-year-old might have. See the design notes in the
 * workbook for the scoring rubric (-2/-1/+1/+2 per item, normalized to
 * a -100..+100 spectrum).
 *
 * Convention: positive score = right side of trait spectrum.
 * For "Emotional Resilience" the Excel measures resilience (high raw
 * = calm), but our spectrum's right side is "Sensitive". Scores below
 * have already been inverted to the display direction.
 */

export interface SampleTrait {
  traitKey: string;
  displayName: string;
  childScore: number;
  parentScore: number;
  childRaw: number;
  parentRaw: number;
}

export const SAMPLE_REPORT_AGE_BAND = "10-12";
export const SAMPLE_REPORT_ITEMS_PER_TRAIT = 8;
export const SAMPLE_CHILD_NAME = "Aanya";

export const sampleTraitData: SampleTrait[] = [
  { traitKey: "openness",          displayName: "Curiosity & Imagination", childScore: 50,  parentScore: 38,  childRaw: 8,  parentRaw: 6 },
  { traitKey: "conscientiousness", displayName: "Focus & Responsibility",  childScore: -25, parentScore: 12,  childRaw: -4, parentRaw: 2 },
  { traitKey: "extraversion",      displayName: "Social Energy",           childScore: 62,  parentScore: 50,  childRaw: 10, parentRaw: 8 },
  { traitKey: "agreeableness",     displayName: "Kindness & Teamwork",     childScore: 69,  parentScore: 56,  childRaw: 11, parentRaw: 9 },
  { traitKey: "neuroticism",       displayName: "Emotional Sensitivity",   childScore: 25,  parentScore: -12, childRaw: 4,  parentRaw: -2 },
];
